import React, { Component } from "react";
import { connect } from "react-redux";
import containsLongRunningProcess from "components/hoc/containsLongRunningProcess";
import { approveKvkk } from "actions";
import i18next from "i18next";
import toastr from "toastr";
import { api } from "api";

class KVKK extends Component {
  state = {
    kvkkCheck: false,
    applicantConsent: false,
    kvkkId: null,
    kvkkContent: null
  };

  componentDidMount = () => {
    this.fetchDefaultKVKKVersion();
  };

  handleKvkkApprove = () => {
    this.props.approveKvkk(
      this.props.kvkkApproveCode,
      this.state.kvkkId,
      this.state.applicantConsent,
      this.onBegin,
      this.onSuccess,
      this.onError
    );
  };

  onBegin = () => {
    this.props.onProcessBegin();
  };

  onSuccess = () => {
    this.props.onProcessEnd();
    toastr.success(i18next.t("10539"), i18next.t("10537"));

    setTimeout(() => {
      window.location.replace("/");
    }, 2000);
  };

  onError = (err) => {
    console.dir(err);
    this.props.onProcessEnd();
    toastr.error(err.data.message, i18next.t("10538"));
  };

  fetchDefaultKVKKVersion = () => {
    api.get(`api/profile/get-default-kvkk-version`)
      .then((response) => {
        this.setState({
          kvkkId: response.data.data.id,
          kvkkContent: response.data.data.content
        });
      })
      .catch((err) => {
        console.error(err);
      });
  }

  render() {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column"
        }}
      >
        {this.props.spinner}

        <div dangerouslySetInnerHTML={{ __html: this.state.kvkkContent }} />

        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input"
            id="kvkkCheck"
            onChange={(e) => {
              this.setState({ kvkkCheck: e.currentTarget.checked });
            }}
          />
          <label
            className="custom-control-label pl-0 formClickArea"
            htmlFor="kvkkCheck"
          >
            <span style={{ color: "red" }}>*</span>
            <span>Kapat</span>
          </label>
        </div>

        <hr style={{ margin: "20px 0" }} />

        {/* <p>
          Ford Otomotiv Sanayi A.Ş. Bayi/Yetkili Servisi Çalışanları ile
          Mezunlar Çalışan Adayı Havuzu Aydınlatma Metni’ne{" "}
          <a
            href="https://fga-scorm.genbil.com/Assets/KVKK/aday-kvkk-20210406.pdf"
            rel="noopener noreferrer"
            target="_blank"
          >
            <b>buradan</b>
          </a>{" "}
          ulaşabilirsiniz.
        </p>
        <p>
          Kişisel verilerime ilişkin tarafıma sunulan{" "}
          <b>
            Ford Otomotiv Sanayi A.Ş. (“Ford Otosan”) Bayi/Yetkili Servisi
            Çalışanları ile Mezunlar Çalışan Adayı Havuzu Aydınlatma Metni
          </b>{" "}
          kapsamında kimlik, iletişim ve çalışma bilgilerimin Ford Otosan Bayi
          Çalışan Havuzu’na eklenmesine ve olası bir ihtiyaç durumunda aynı ya
          da farklı bir ilde bir pozisyon için değerlendirilmek üzere belirtilen
          kişisel verilerimin ilgili diğer Ford Otosan bayileri/yetkili
          servisleri ve çağrı merkezi hizmeti sunan tedarikçi firma ile
          paylaşılmasına ve ilgili kişilerce bu doğrultuda işlenmesine açık bir
          şekilde rıza verdiğimi kabul ediyorum.
        </p>

        <div className="custom-control custom-checkbox">
          <input
            type="checkbox"
            className="custom-control-input"
            id="applicantConsent"
            onChange={(e) => {
              this.setState({ applicantConsent: e.currentTarget.checked });
            }}
          />
          <label
            className="custom-control-label pl-0 formClickArea"
            htmlFor="applicantConsent"
          >
            <span> Okudum, anladım, onaylıyorum</span>
          </label>
        </div> */}

        <div style={{ justifySelf: "end" }}>
          <button
            type="submit"
            className={`kvkk-save btn btn-fga-primary ${this.state.kvkkCheck ? "" : "disabled"
              }`}
            onClick={(e) => this.handleKvkkApprove(e)}
          >
            Kaydet
          </button>
        </div>
      </div>
    );
  }
}

export default connect(null, {
  approveKvkk,
})(containsLongRunningProcess(KVKK));
